import { observable, makeObservable } from 'mobx';

export default class ImageGridVersion4 {

  id = null;
  type = null;
  alt = null;
  leftSquareImage = null;
  rightUpperRectangularImage = null;
  rightLowerSquareImages = null;
  additionalPaddingBelowComponent = null;

  constructor(props) {
    makeObservable(this, {
      id: observable,
      type: observable,
      alt: observable,
      leftSquareImage: observable,
      rightUpperRectangularImage: observable,
      rightLowerSquareImages: observable,
      additionalPaddingBelowComponent: observable
    });

    this.id = props.id
    this.type = props.type
    this.alt = props.alt
    this.leftSquareImage = props.leftSquareImage
    this.rightUpperRectangularImage = props.rightUpperRectangularImage
    this.rightLowerSquareImages = props.rightLowerSquareImages
    this.additionalPaddingBelowComponent = props.additionalPaddingBelowComponent
  }
} 